import { render, staticRenderFns } from "./TableSingleSelected.vue?vue&type=template&id=45acc0fa"
import script from "./TableSingleSelected.vue?vue&type=script&lang=js"
export * from "./TableSingleSelected.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports